import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useKaylas } from "@/lib/kaylasAuth";
import { MUM_HERO_LOGO } from "./assets";
import { Lock, Loader2, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import "@/kaylas/theme.css";

export default function KaylasLogin() {
  const { login } = useKaylas();
  const nav = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(username.trim(), password);
      nav("/kaylas-garden/home", { replace: true });
    } catch (e2) {
      setErr(e2.response?.data?.detail || "That doesn&apos;t open the shed door.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="kaylas-theme min-h-screen flex items-center justify-center px-5 py-10" data-testid="mums-login-page">
      <div className="mum-bg-layer" style={{ backgroundImage: 'url(/mums-shed/background.png)' }} aria-hidden="true" />
      <Link to="/" className="absolute top-5 left-5 mum-btn-ghost" data-testid="mum-back-to-bloom">
        <ArrowLeft size={14} /> Back to Bloom Keeper
      </Link>

      <div className="kaylas-card w-full max-w-md p-8 sm:p-12 text-center animate-bloom-in" data-testid="mums-login-card">
        <img
          src={MUM_HERO_LOGO}
          alt="Kayla's Garden"
          className="w-32 h-32 mx-auto rounded-full ring-2 ring-[var(--mum-cornflower)] shadow-[0_18px_36px_-18px_rgba(15,27,60,0.45)] mum-shimmer"
        />
        <div className="mum-chip mx-auto mt-5">Kayla's Secret Garden Manager</div>
        <h1 className="font-display text-5xl mt-3 text-[var(--mum-sapphire)] leading-none">Kayla&apos;s Garden</h1>
        <p className="font-display italic text-[var(--mum-cobalt)] mt-2">Kayla&apos;s Dahlias at Heritage</p>
        <div className="mum-divider mt-4">tend the patch</div>

        <form onSubmit={submit} className="mt-6 space-y-3 text-left" data-testid="mums-login-form">
          <label className="block">
            <span className="text-xs uppercase tracking-[0.18em] text-[var(--mum-cobalt)]">Gardener</span>
            <input
              type="text"
              className="mum-field mt-1.5"
              placeholder="Your name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              data-testid="mums-username"
              autoComplete="username"
              required
            />
          </label>
          <label className="block">
            <span className="text-xs uppercase tracking-[0.18em] text-[var(--mum-cobalt)]">Passphrase</span>
            <input
              type="password"
              className="mum-field mt-1.5"
              placeholder="A secret word"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="mums-password"
              autoComplete="current-password"
              required
            />
          </label>
          {err && (
            <div className="text-sm text-[var(--mum-sapphire)] bg-[var(--mum-sky)]/60 rounded-lg px-3 py-2 border border-[var(--mum-cornflower)]" data-testid="mums-login-error">
              {err}
            </div>
          )}
          <button type="submit" className="mum-btn w-full mt-2" disabled={busy} data-testid="mums-login-submit">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <Lock size={15} />}
            {busy ? "Opening…" : "Open the garden"}
          </button>
        </form>
      </div>
    </div>
  );
}
